import { resolveStoredFileUrl } from "utils/storedFileUrl";
import { Card, Icon } from '@mui/material';
import SoftBox from 'components/SoftBox';
import SoftButton from 'components/SoftButton';
import SoftTypography from 'components/SoftTypography';
import { MessageManager } from 'context';
import SoftBadge from "components/SoftBadge";
import React, { memo, useContext, useCallback, useState } from 'react';
import menuIcon from "assets/images/icons/menu.png";
import { formatMoneyPunto } from 'utils/formatters';
import sinTacc from "assets/images/icons/sin-tacc.png";
import vegetariano from "assets/images/icons/vegetariano.png";
import SoftInputNumber from 'components/SoftInputNumberUpgrade';

function ProductCardConsumoInterno({ prod, isSelected, handleUpdate, handleAddDetalle, detalles }) {
    const { handleSnackbar } = useContext(MessageManager);
    const [editPrice, setEditPrice] = useState(false);
    const [customPrice, setCustomPrice] = useState(prod?.precioCarta ?? 0);

    const getPrecioActual = (cantidad) => {
        return prod?.precioEditado != null ? Number(prod?.precioEditado) : Number(prod?.precioCarta ?? 0);
    };

    const precioMostrado = getPrecioActual(prod?.cantidad ?? 1);

    const disSum = (prod, addButton = false) => {
        const detalleExistente = detalles.find(
            (detalle) => detalle.producto?.id === prod.id && detalle.estado === "PENDIENTE"
        );
        let stock = addButton ? prod?.stockCantidad + 1 : prod?.stockCantidad;
        const cantidadDetalle = detalleExistente ? detalleExistente.cantidad : 0;
        return stock && (prod?.cantidad + cantidadDetalle) >= stock;
    };

    const handleIncrement = useCallback((e) => {
        e.stopPropagation();
        const cantidadActual = prod?.cantidad || 1;
        const detalleExistente = detalles.find(
            (detalle) => detalle.producto?.id === prod.id && detalle.estado === "PENDIENTE"
        );
        const cantidadDetalle = detalleExistente ? detalleExistente.cantidad : 0;
        const nuevaCantidad = parseInt(cantidadActual + 1);

        let newProdData = {
            ...prod,
            cantidad: nuevaCantidad,
            cantidadDetalle: cantidadDetalle,
            precioEditado: precioMostrado,
        };
        handleUpdate(newProdData);
    }, [prod, handleSnackbar, precioMostrado]);

    const handleDecrement = useCallback((e) => {
        e.stopPropagation();
        const nuevaCantidad = parseInt(prod?.cantidad || 1) > 1 ? parseInt(prod?.cantidad) - 1 : 1;
        let newProdData = {
            ...prod,
            cantidad: nuevaCantidad,
            precioEditado: precioMostrado,
        };
        handleUpdate(newProdData);
    }, [prod, precioMostrado]);

    const handleSetGratis = useCallback((e) => {
        e.stopPropagation();

        const newProdData = {
            ...prod,
            precioEditado: 0,
        };

        setCustomPrice(0);
        handleUpdate(newProdData);            
        handleAddDetalle(newProdData);       
        handleSnackbar("Producto agregado gratis.", "success");
    }, [prod, handleUpdate, handleSnackbar, handleAddDetalle]);

    const handleChangePrice = useCallback((e) => {
        e.stopPropagation();
        setCustomPrice(prod?.precioCarta ?? 0);
        setEditPrice(true);
    }, []);

    const handlePriceInputChange = useCallback((e) => {
        const value = e.target.value;
        if (value >= 0 || value === '') {
            setCustomPrice(value);
            let newProdData = {
                ...prod,
                precioEditado: value === '' ? null : parseFloat(value),
            };
            handleUpdate(newProdData);
        }
    }, [prod, handleUpdate]);

    return (
        <Card
            sx={{
                borderRadius: 3,
                overflow: "hidden",
                border: "1px solid rgba(0, 0, 0, 0.12)",
                boxShadow: isSelected
                    ? `0 0 16px 4px rgba(200, 200, 200, 0.8), 0 0 32px 8px rgba(200, 200, 200, 0.6)`
                    : undefined,
                position: "relative",
                minHeight: 240,
            }}
        >
            <SoftBox
                sx={{
                    position: "relative",
                    width: "100%",
                    paddingBottom: "100%",
                    overflow: "hidden",
                    backgroundColor: "#f5f5f5",
                    cursor: "pointer",
                }}
                onClick={() => {
                    let prodReset = { ...prod, cantidad: 1, precioEditado: prod?.precioEditado ?? prod?.precioCarta ?? 0 };
                    handleUpdate(prodReset);
                }}
            >
                <SoftBox
                    sx={{
                        position: "absolute",
                        top: 12,
                        right: 12,
                        zIndex: 3,
                    }}
                >
                    <SoftBadge
                        color="primary"
                        badgeContent={
                            precioMostrado === 0
                                ? "SIN PRECIO"
                                : `$${formatMoneyPunto(precioMostrado)}`
                        }
                        container
                    />
                </SoftBox>
                <SoftBox
                    component="img"
                    loading="lazy"
                    src={
                        prod?.files && prod?.files?.length > 0
                            ? resolveStoredFileUrl(prod?.files[0]?.file)
                            : prod?.tipoProducto?.tipo === "Vegetariano"
                                ? vegetariano
                                : prod?.tipoProducto?.tipo === "Libre de gluten"
                                    ? sinTacc
                                    : menuIcon
                    }
                    alt={prod?.nombre}
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        maxWidth: "100%",
                        objectFit: prod?.files && prod?.files?.length > 0 ? "cover" : "contain",
                        objectPosition: "center",
                        opacity: isSelected ? 0.15 : 1,
                        transition: "opacity 0.3s",
                        zIndex: 1,
                    }}
                />
                {isSelected && (
                    <SoftBox
                        sx={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 2,
                            pointerEvents: "none",
                        }}
                    >
                        <SoftBox
                            sx={{
                                width: "85%",
                                background: "rgba(255,255,255,0.98)",
                                borderRadius: 2,
                                p: 1,
                                boxShadow: 3,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: 1,
                                pointerEvents: "auto",
                            }}
                        >
                            <SoftBox
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: 2,
                                    mb: 1,
                                }}
                            >
                                <SoftButton
                                    circular
                                    iconOnly
                                    color="secondary"
                                    onClick={handleDecrement}
                                    disabled={prod?.cantidad <= 1}
                                    sx={{
                                        fontSize: 24,
                                    }}
                                >
                                    <Icon sx={{ fontSize: 28 }}>remove</Icon>
                                </SoftButton>
                                <SoftTypography variant="h6" sx={{ minWidth: 24, textAlign: "center", fontWeight: "bold", color: "#222" }}>
                                    {prod?.cantidad}
                                </SoftTypography>
                                <SoftButton
                                    circular
                                    iconOnly
                                    color="warning"
                                    onClick={handleIncrement}
                                    disabled={disSum(prod) || prod?.disabledStock}
                                    sx={{
                                        fontSize: 24,
                                    }}
                                >
                                    <Icon sx={{ fontSize: 28 }}>add</Icon>
                                </SoftButton>
                            </SoftBox>
                            <SoftBox
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 1,
                                    width: "100%",
                                }}
                            >
                                {!editPrice && <SoftButton
                                    circular
                                    color="info"
                                    sx={{ minWidth: 48 }}
                                    onClick={handleSetGratis}
                                >
                                    AGREGAR GRATIS
                                </SoftButton>}
                                <SoftBox
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 1,
                                        width: "100%",
                                    }}
                                >
                                    {!editPrice && (<SoftButton
                                        circular
                                        color="warning"
                                        sx={{ minWidth: 48 }}
                                        onClick={handleChangePrice}
                                    >
                                        CAMBIAR PRECIO
                                    </SoftButton>)}
                                    {editPrice && (
                                        <SoftInputNumber
                                            value={customPrice}
                                            onChange={handlePriceInputChange}
                                            onClick={(e) => e.stopPropagation()}
                                            placeholder="Nuevo precio"
                                            inputProps={{ min: 0 }}
                                        />
                                    )}
                                </SoftBox>
                                <SoftButton
                                    circular
                                    color="uproGreen"
                                    sx={{ minWidth: 48 }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setEditPrice(false);
                                        handleAddDetalle();
                                    }}
                                    disabled={
                                        !prod?.nombre ||
                                        !prod?.cantidad ||
                                        prod?.cantidad < 1 ||
                                        (prod?.stockCantidad && prod?.cantidad > prod?.stockCantidad) ||
                                        prod.disabledStock ||
                                        disSum(prod, true)
                                    }
                                >
                                    {prod.disabledStock || disSum(prod, true) ? "Sin Stock" : editPrice ? "AGREGAR MODIFICADO" : "AGREGAR"}&nbsp;
                                    {prod.disabledStock || disSum(prod, true) ? null : <Icon sx={{ fontSize: 28 }}>add</Icon>}
                                </SoftButton>
                            </SoftBox>
                        </SoftBox>
                    </SoftBox>
                )}
            </SoftBox>
            <SoftBox
                display="flex"
                gap={2}
                justifyContent="space-between"
                alignItems="center"
                p={2}
            >
                <SoftBox display="flex" flexDirection="column">
                    <SoftTypography variant="h6">{prod?.nombre}</SoftTypography>
                    {prod?.tipoProducto?.tipo && (
                        <SoftTypography variant="h7" fontWeight="regular">
                            {prod?.tipoProducto.tipo}
                        </SoftTypography>
                    )}
                </SoftBox>
            </SoftBox>
        </Card>
    );
}

export default memo(ProductCardConsumoInterno);
